import ApexCharts from "apexcharts";
import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import ChartExportControl from "../../../core/common/ChartExportControl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import CollapseHeader from "../../../core/common/collapse-header";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Tooltip as AntdTooltip } from "antd";
import { RootState } from "../../../core/data/interface";
import { Button, Container, Modal } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
  PieChart,
  Pie,
  Cell,
  ReferenceLine,
  AreaChart,
  Area,
} from "recharts";
import ReactApexChart from "react-apexcharts";
import { FaCheckCircle, FaPhone, FaUserSlash } from "react-icons/fa";
import { FiTrendingDown } from "react-icons/fi";
import moment from "moment";
import { all_routes } from "../../router/all_routes";
import {
  createNote,
  deleteNote,
  getNotesByUserId,
  Note,
  updateNote,
} from "../../../api/notes";
import {
  fetchLeadStatsByUser,
  LeadCountsFunnel,
  LeadStats,
  TodoItem,
  DealStatusCount,
} from "../../../api/userdashboard";
import { CalendarEvent, getAllCalendarEvents } from "../../../api/calander";
import { getLeadsByUserId, Lead } from "../../../api/lead";
import { getIncentiveByUser, Incentive } from "../../../api/target";
import { fetchLeadStats, TargetDetail } from "../../../api/dashboard";
import { fetchUsersByClientId } from "../../../api/todo";
import { ApexOptions } from "apexcharts";
import PageLoadProgressBar from "../../../core/data/json/pageLoadProgressBar";
import Tip from "../../../core/common/tooltip";
const theme = {
  contacted: "#ffc107",
  notContacted: "#17a2b8",
  closed: "#6366F1",
  lost: "#dc3545",
  won: "#28a745",
  open: "#ffc107",
};

function numberToWords(num: number): string {
  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  if (num === 0) return "Zero";
  if (num < 20) return a[num];
  if (num < 100)
    return b[Math.floor(num / 10)] + (num % 10 ? " " + a[num % 10] : "");
  if (num < 1000)
    return (
      a[Math.floor(num / 100)] +
      " Hundred" +
      (num % 100 ? " " + numberToWords(num % 100) : "")
    );
  if (num < 100000)
    return (
      numberToWords(Math.floor(num / 1000)) +
      " Thousand" +
      (num % 1000 ? " " + numberToWords(num % 1000) : "")
    );
  if (num < 10000000)
    return (
      numberToWords(Math.floor(num / 100000)) +
      " Lakh" +
      (num % 100000 ? " " + numberToWords(num % 100000) : "")
    );
  return (
    numberToWords(Math.floor(num / 10000000)) +
    " Crore" +
    (num % 10000000 ? " " + numberToWords(num % 10000000) : "")
  );
}

const noteColors = [
  "#f8d7da",
  "#d4edda",
  "#fff3cd",
  "#e2e3f3",
  "#f5c6cb",
  "#d1ecf1",
];
const LeadsDashboard = () => {
  const route = all_routes;
  const [notes, setNotes] = useState<Note[]>([]);
  const [noteDescription, setNoteDescription] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNote, setSelectedNote] = useState<Note | null>(null);
  const [selectedNoteId, setSelectedNoteId] = useState<string | null>(null);
  const [incentive, setIncentive] = useState<Incentive | null>(null);
  const [dealRevenueData, setDealRevenueData] = useState<
    { name: string;[status: string]: number | string }[]
  >([]); // Changed from productRevenueData to dealRevenueData
  const [statusDetails, setStatusDetails] = useState<
    { status: string; count: number }[]
  >([]);
  const [leadStats, setLeadStats] = useState<LeadStats | null>(null);
  const [filterDays, setFilterDays] = useState(30);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [todayLeadCount, setTodayLeadCount] = useState(0);
  const [isIncentiveLoading, setIsIncentiveLoading] = useState(false);
  const rowsPerPage = 5;
  const userId = useSelector((state: RootState) => state.auth.user_id);
  const bgColors = ["#E9EAFE", "#FFF1DA", "#D6F5E8", "#FFE9E9"];
  const COLORS = ["#f5222d", "#fa8c16", "#1890ff", "#d9d9d9"];
  const LEAD_STATUS_ORDER = ["Contacted", "Not_Contacted", "Closed", "Lost"];

  const [leads, setLeads] = useState<Lead[]>([]);
  const [target, setTarget] = useState<number | null>(null);

  const [showLoader, setShowLoader] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [currentUserName, setCurrentUserName] = useState("");
  const navigate = useNavigate();
  const [events, setEvents] = useState<any[]>([]);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const clientId = useSelector((state: RootState) => state.auth.client_id);
  const currentUserNameRef = useRef<string | null>(null);
  const [targetData, setTargetData] = useState<TargetDetail[]>([]);
  const [userNames, setUserNames] = useState<string[]>([]);
  const [dealStages, setDealStages] = useState<
    { label: string; total: number }[]
  >([]);
  const [selectedBar, setSelectedBar] = useState<{
    seriesIndex: number;
    dataPointIndex: number;
  } | null>(null);
  const [showExplanation, setShowExplanation] = useState(false);
  const [sortBy, setSortBy] = useState<"all" | "2x" | "5x">("all");
  const [todos, setTodos] = useState<TodoItem[]>([]);
  const [selectedTodo, setSelectedTodo] = useState<TodoItem | null>(null);
  const [showTodoModal, setShowTodoModal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrolled = (scrollTop / docHeight) * 100;
      setScrollProgress(scrolled);

      const atBottom =
        window.innerHeight + scrollTop >= document.body.offsetHeight - 50;
      setShowScrollTop(atBottom);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    currentUserNameRef.current = currentUserName; // Update ref when state changes
  }, [currentUserName]);

  useEffect(() => {
    if (
      leadStats?.get_dealstatuscount &&
      leadStats.get_dealstatuscount.length > 0
    ) {
      const dealCounts = leadStats.get_dealstatuscount.reduce(
        (acc, curr) => ({ ...acc, ...curr }),
        {}
      );

      const dealStageData = [
        { label: "Open", total: dealCounts.total_deals_open || 0 },
        { label: "Closed", total: dealCounts.total_deals_closed || 0 },
        { label: "Won", total: dealCounts.total_deals_won || 0 },
        { label: "Lost", total: dealCounts.total_deals_lost || 0 },
      ];

      setDealStages(dealStageData);
    }
  }, [leadStats]);

  useEffect(() => {
    const loadTargetStats = async () => {
      try {
        if (!clientId) return;

        const [users, leadStats] = await Promise.all([
          fetchUsersByClientId(clientId),
          fetchLeadStats(),
        ]);
        const rawTargets = leadStats?.get_all_targets;
        const targets = Array.isArray(rawTargets)
          ? rawTargets
          : rawTargets?.data ?? [];

        setTargetData(targets);
        // Match user names by user ID
        const nameMap = users.reduce((acc, user) => {
          acc[user.id] = user.name;
          return acc;
        }, {} as Record<string, string>);

        setUserNames(targets.map((t) => nameMap[t.user_id] || "Unknown"));
      } catch (error) {
        console.error("Error loading target stats:", error);
      }
    };

    loadTargetStats();
  }, [clientId]);

  useEffect(() => {
    if (
      leadStats?.get_dealstatuscount &&
      leadStats.get_dealstatuscount.length > 0
    ) {
      const deal = leadStats.get_dealstatuscount[0]; // since it’s only one object
      const stages = [
        { name: "Total Deals", value: deal.total_deal || 0 },
        { name: "Deals Closed", value: deal.total_deals_closed || 0 },
        { name: "Deals Open", value: deal.total_deals_open || 0 },
        { name: "Deals Lost", value: deal.total_deals_lost || 0 },
        { name: "Deals Won", value: deal.total_deals_won || 0 },
      ];

      const validStages = stages.filter((stage) => stage.value > 0);
      validStages.sort((a, b) => b.value - a.value);

      const seriesData = validStages.map((s) => s.value);
      const categories = validStages.map((s) => `${s.name}: ${s.value}`);

      setFunnelChartOptions((prev: any) => ({
        ...prev,
        series: [{ name: "", data: seriesData }],
        xaxis: { categories },
      }));
    }
  }, [leadStats]);

  const topPerformers = useMemo(() => {
    let filtered = [...targetData];

    if (sortBy === "2x") {
      filtered = filtered.filter((u) => u.incentive_percentage === 2);
    } else if (sortBy === "5x") {
      filtered = filtered.filter((u) => u.incentive_percentage === 5);
    }

    return filtered
      .sort(
        (a, b) => (b.calculated_incentive || 0) - (a.calculated_incentive || 0)
      )
      .slice(0, 5);
  }, [targetData, sortBy]);

  useEffect(() => {
    if (
      leadStats?.get_lead_counts_funnel &&
      leadStats.get_lead_counts_funnel.length > 0
    ) {
      // Merge the array of objects into a single object
      const funnelData = leadStats.get_lead_counts_funnel.reduce(
        (acc, curr) => ({ ...acc, ...curr }),
        {} as LeadCountsFunnel
      );

      // Define stages for the funnel chart
      const stages = [
        { name: "Total Leads", value: funnelData.total_leads || 0 },
        { name: "Not Contacted", value: funnelData.not_contacted_leads || 0 },
        { name: "Closed Leads", value: funnelData.closed_leads || 0 },
        { name: "Deals Won", value: funnelData.deals_won || 0 },
      ];

      // Filter out stages with zero values
      const validStages = stages.filter((stage) => stage.value > 0);

      // Sort stages in descending order (largest to smallest)
      validStages.sort((a, b) => b.value - a.value);

      // Prepare series data and categories
      const seriesData = validStages.map((stage) => stage.value);
      const categories = validStages.map(
        (stage) => `${stage.name}: ${stage.value}`
      );

      setFunnelChartOptions((prev: any) => ({
        ...prev,
        series: [
          {
            name: "",
            data: seriesData,
          },
        ],
        xaxis: {
          categories: categories,
        },
      }));
    }
  }, [leadStats]);

  const [funnelChartOptions, setFunnelChartOptions] = useState<any>({
    series: [
      {
        name: "",
        data: [],
      },
    ],
    chart: {
      type: "bar",
      height: 420,
      events: {
        dataPointSelection: (
          event: any,
          chartContext: any,
          { dataPointIndex }: any
        ) => {
          const category =
            chartContext.w.config.xaxis.categories[dataPointIndex];
          let label = category; // Use label as a working copy of category

          if (label) {
            if (label.startsWith("Not")) label = "Not_Contacted";
            else if (label.startsWith("Total")) {
              navigate("/leads"); // Show all leads without status filter
              return; // Exit the function to prevent further navigation
            } else if (label.startsWith("Closed")) label = "Closed";
            else if (label.startsWith("Deals")) label = "Closed";
          }

          if (label && currentUserNameRef.current) {
            navigate(
              `/leads?status=${encodeURIComponent(
                label
              )}&owner=${encodeURIComponent(currentUserNameRef.current)}`
            );
          } else if (!currentUserNameRef.current) {
            toast.error("User name not found. Please wait for data to load.");
          } else {
            toast.error(
              "Category not found or invalid. Please ensure chart data is loaded."
            );
          }
        },
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
        distributed: true,
        barHeight: "100%",
        isFunnel: true,
      },
    },
    colors: ["#4A00E5", "#1ECBE2", "#FF9D0A", "#00918E"],
    dataLabels: {
      enabled: true,
      formatter: function (val: number, opts: any) {
        const totalLeads = opts.w.config.series[0].data[0]; // Total leads is first in descending order
        const percentage =
          totalLeads > 0 ? ((val / totalLeads) * 100).toFixed(0) : "0";
        return `${val} (${percentage}%)`; // e.g., "3 (100%)"
      },
      style: {
        fontSize: "12px",
        fontWeight: "bold",
        colors: ["#fff"],
      },
      dropShadow: {
        enabled: true,
      },
    },
    tooltip: {
      enabled: true,
      formatter: function (val: number, opts: any) {
        const totalLeads = opts.w.config.series[0].data[0];
        const percentage =
          totalLeads > 0 ? ((val / totalLeads) * 100).toFixed(2) : "0.00";
        return `${opts.w.globals.labels[opts.dataPointIndex]
          }<br>Count: ${val}<br>Conversion Rate: ${percentage}%`;
      },
    },
    xaxis: {
      categories: [],
    },
    legend: {
      show: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: { height: 300 },
          plotOptions: { bar: { barHeight: "80%" } },
          dataLabels: {
            style: { fontSize: "10px" },
          },
        },
      },
    ],
  });
  const RevenueChart: ApexOptions = {
    chart: {
      height: 380,
      type: "bar",
      stacked: true,
      toolbar: { show: false },
      events: {
        dataPointSelection: (
          event,
          chartContext,
          { seriesIndex, dataPointIndex }
        ) => {
          setSelectedBar({ seriesIndex, dataPointIndex });
        },
      },
    },

    colors: ["#00B8D9", "#36B37E", "#FFAB00", "#FF5630", "#6554C0", "#2684FF"],

    plotOptions: {
      bar: {
        borderRadius: 5,
        horizontal: true, // ✅ Make it horizontal
        barHeight: "60%",
        dataLabels: {
          position: "right",
        },
      },
    },

    xaxis: {
      categories: userNames, // ✅ Keep this here
      labels: {
        formatter: (val: string) => val, // ✅ Fix TS error by accepting string
        style: { fontSize: "13px", colors: "#6B7280" },
      },
      title: {
        text: "User",
        style: { fontSize: "13px", color: "#6B7280" },
      },
    },

    yaxis: {
      labels: {
        formatter: (val: number) => `₹${val}`, // ✅ y-axis is now value-based
        style: { fontSize: "12px", colors: "#6B7280" },
      },
      title: {
        text: "Amount (₹)",
        style: { fontSize: "13px", color: "#6B7280" },
      },
    },

    dataLabels: { enabled: false },
    tooltip: {
      shared: true,
      intersect: false,
      custom: function ({ series, dataPointIndex, w }) {
        const labels = [
          "Salary",
          "Target(20x)",
          "Incentive Target(5x)",
          "Total Deal Value",
          "Incentive %",
          "Calculated Incentive",
          "Incentive Achieved Amount",
        ];
        const colors = w.config.colors;
        let tooltipHtml = `<div style="padding:10px"><strong>${w.globals.labels[dataPointIndex]}</strong><br/>`;
        for (let i = 0; i < series.length; i++) {
          const value = series[i][dataPointIndex] || 0;
          const isHighlighted =
            selectedBar?.seriesIndex === i &&
            selectedBar?.dataPointIndex === dataPointIndex;
          const isPercentage = labels[i] === "Incentive %";
          tooltipHtml += `
        <div style="display:flex; align-items:center; margin-bottom:4px; font-weight:${isHighlighted ? "bold" : "normal"
            };">
          <span style="display:inline-block; width:10px; height:10px; background-color:${colors[i]
            }; border-radius:50%; margin-right:8px;"></span>
          <span style="${isHighlighted ? "color:#000;" : ""}">
            <strong>${labels[i]}:</strong> ${isPercentage
              ? `${value}%`
              : `₹${value} <span style="color:#6b7280; font-size:11px;">(${numberToWords(
                Math.round(value)
              )})</span>`
            }
          </span>
        </div>`;
        }
        tooltipHtml += `</div>`;
        return tooltipHtml;
      },
    },

    legend: {
      position: "top",
      horizontalAlign: "right",
      offsetY: 0,
    },

    responsive: [
      {
        breakpoint: 992,
        options: {
          chart: { height: 480 },
          plotOptions: { bar: { barHeight: "50%" } },
          legend: {
            position: "bottom",
            horizontalAlign: "center",
            offsetY: 10,
          },
        },
      },
      {
        breakpoint: 576,
        options: {
          chart: { height: 450 },
          plotOptions: { bar: { barHeight: "55%" } },
          xaxis: {
            labels: {
              style: {
                fontSize: "10px",
              },
            },
          },
        },
      },
    ],
  };

  const RevenueSeries = [
    {
      name: "Salary",
      data: targetData.map((t) => t.salary || 0),
    },
    {
      name: "Target",
      data: targetData.map((t) => t.target || 0),
    },
    {
      name: "Incentive Target",
      data: targetData.map((t) => t.incentive_target || 0),
    },
    {
      name: "Total Deal Value",
      data: targetData.map((t) => t.total_deal_value || 0),
    },
    {
      name: "Incentive %",
      data: targetData.map((t) => t.incentive_percentage || 0),
    },
    {
      name: "Calculated Incentive",
      data: targetData.map((t) => t.calculated_incentive || 0),
    },
    {
      name: "Incentive Achieved Amount",
      data: targetData.map((t) => t.incentive_achieved_amount || 0),
    },
  ];

  useEffect(() => {
    const loadDashboardData = async () => {
      try {
        if (!userId) {
          toast.error("User ID missing. Please log in.");
          return;
        }

        setShowLoader(true);

        // 🔥 Fetch everything in parallel instead of sequentially
        const [
          stats,
          leadsData,
          notesData,
          incentiveData,
          usersByClient,
          allEvents,
        ] = await Promise.all([
          fetchLeadStatsByUser(userId),
          getLeadsByUserId(userId),
          getNotesByUserId(userId),
          getIncentiveByUser(userId),
          clientId ? fetchUsersByClientId(clientId) : Promise.resolve([]),
          getAllCalendarEvents(),
        ]);

        // 🔥 Set state only ONCE (batch update → 1 re-render)
        setLeadStats(stats);
        setLeads(leadsData || []);
        setNotes(notesData || []);
        setIncentive(incentiveData || null);
        setTarget(incentiveData?.target ?? null);
        setEvents(
          allEvents
            ?.filter((e) => moment(e.event_start).isSameOrAfter(moment()))
            ?.sort(
              (a, b) =>
                moment(a.event_start).valueOf() -
                moment(b.event_start).valueOf()
            )
        );

        // set current user name
        if (clientId && usersByClient.length > 0) {
          const current = usersByClient.find((u) => u.id === userId);
          setCurrentUserName(current?.name || "");
          currentUserNameRef.current = current?.name || "";
        }
      } catch (err) {
        console.error(err);
      } finally {
        setShowLoader(false);
      }
    };

    loadDashboardData();
  }, [userId, clientId]);

  useEffect(() => {
    if (leadStats?.deal_summary && leadStats.deal_summary.length > 0) {
      const revenueMap: Record<string, number> = {};

      leadStats.deal_summary.forEach((deal) => {
        const status = (deal.status || "Unknown").trim().toLowerCase();
        const value = deal.total_value || 0;

        // Map any variation to the 4 standard keys the chart expects
        let key = "Unknown";
        if (["won", "win", "w"].includes(status)) key = "won";
        else if (["lost", "lose", "l"].includes(status)) key = "Lost";
        else if (["open", "in progress", "pipeline"].includes(status))
          key = "Open";
        else if (["closed", "close", "c"].includes(status)) key = "Closed";

        revenueMap[key] = (revenueMap[key] || 0) + value;
      });

      // Always include all 4 keys so bars are rendered even if value = 0
      const completeMap = {
        won: revenueMap.won || 0,
        Lost: revenueMap.Lost || 0,
        Open: revenueMap.Open || 0,
        Closed: revenueMap.Closed || 0,
      };

      const chartData = [{ name: "Deals", ...completeMap }];
      setDealRevenueData(chartData);
    } else {
      setDealRevenueData([]);
    }
  }, [leadStats]);

  const salary = leadStats?.calculate_user_incentive.salary ?? 0;
  const targets = leadStats?.calculate_user_incentive.target ?? 1;
  const incentiveTarget =
    leadStats?.calculate_user_incentive.incentive_target ?? 0;
  const dealValue = leadStats?.calculate_user_incentive.total_deal_value ?? 0;
  const calculatedIncentive =
    leadStats?.calculate_user_incentive.calculated_incentive ?? 0;
  const incentivePercentage =
    leadStats?.calculate_user_incentive.incentive_percentage ?? 0;

  const isTargetAchieved = dealValue >= targets;
  const isIncentiveAchieved = dealValue >= targets + incentiveTarget;

  const headerLabel = isIncentiveAchieved
    ? "🎯 Target & Incentive Achieved"
    : isTargetAchieved
      ? `₹${dealValue} / ₹${targets + incentiveTarget}`
      : `₹${dealValue} / ₹${targets}`;

  const incentiveAchieved = Math.max(dealValue - targets, 0);
  const remainingIncentive = Math.max(incentiveTarget - incentiveAchieved, 0);
  let headerSubText = "";

  if (!isTargetAchieved) {
    headerSubText =
      "You're progressing toward your main target. Keep closing deals to reach the goal.";
  } else if (!isIncentiveAchieved) {
    headerSubText =
      "You've reached your target! Push further to unlock your incentive.";
  } else {
    headerSubText =
      "Awesome work! You've completed your full target and earned your incentive.";
  }

  const getSegmentWidth = (value: number, base: number): string => {
    if (!base || base <= 0) return "0%";
    return `${Math.min((value / base) * 100, 100)}%`;
  };

  const progressContainerStyle: React.CSSProperties = {
    height: "18px",
    borderRadius: "999px",
    overflow: "hidden",
    backgroundColor: "#F1F5F9",
    boxShadow: "inset 0 1px 2px rgba(15,23,42,0.08)",
  };

  const progressSegmentStyle: React.CSSProperties = {
    height: "100%",
    display: "inline-block", // important so width works correctly
    transition: "width 0.5s ease",
    borderRadius: "999px",
  };

  // Process product revenue data and status details
  // useEffect(() => {
  //   if (leadStats) {
  //     // Product revenue data
  //     const revenueMap: Record<string, Record<string, number>> = {};
  //     leadStats.deal_summary?.forEach((deal) => {
  //       const productName =
  //         leadStats.product_type?.find((p) => p.total_leads > 0)?.product_name || "Unknown";
  //       const status = deal.status || "Unknown";
  //       const value = deal.total_value || 0;
  //       if (!revenueMap[productName]) revenueMap[productName] = {};
  //       revenueMap[productName][status] = (revenueMap[productName][status] || 0) + value;
  //     });
  //     const chartData = Object.entries(revenueMap).map(([productName, statusMap]) => ({
  //       name: productName,
  //       ...statusMap,
  //     }));
  //     setProductRevenueData(chartData);

  //     // Lead status details
  //     const statusData = leadStats.lead_summary?.map((s) => ({
  //       status: s.status,
  //       count: s.lead_count,
  //     })) || [];
  //     setStatusDetails(statusData);
  //   }
  // }, [leadStats]);

  // Calculate today's leads

  useEffect(() => {
    const calculateTodayLeads = () => {
      const today = moment().startOf("day");
      const leadsToday = leads.filter((lead) =>
        moment(lead.created_at).isSame(today, "day")
      );
      setTodayLeadCount(leadsToday.length);
    };
    calculateTodayLeads();
  }, [leads]);

  // Modal handlers for notes
  const openModal = (note?: Note) => {
    if (note) {
      setSelectedNote(note);
      setNoteDescription(note.notes_decription);
    } else {
      setSelectedNote(null);
      setNoteDescription("");
    }
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedNote(null);
    setNoteDescription("");
  };

  const saveNote = async (
    selectedNote: Note | null,
    noteDescription: string
  ) => {
    //try {
    if (!userId) {
      console.error("User ID not found. Please log in.");
      return;
    }
    if (selectedNote) {
      await updateNote(selectedNote.note_id, noteDescription);
      // toast.success("Note updated successfully");
    } else {
      await createNote(noteDescription);
      // toast.success("Note created successfully");
    }
    const notesData = await getNotesByUserId(userId);
    setNotes(notesData || []);
    closeModal();
    // } catch (error) {
    //   console.error("Error saving note:", error);
    // }
  };

  const handleConfirmDelete = (noteId: string) => {
    setSelectedNoteId(noteId);
  };

  const confirmDeleteNote = async (selectedNoteId: string | null) => {
    if (selectedNoteId && userId) {
      try {
        await deleteNote(selectedNoteId);
        toast.success("Note deleted successfully");
        const notesData = await getNotesByUserId(userId);
        setNotes(notesData || []);
      } catch (error) {
        console.error("Error deleting note:", error);
      } finally {
        setSelectedNoteId(null);
      }
    }
  };

  // Chart refs
  const chartRef = useRef<HTMLDivElement>(null);
  const leadsByStageRef = useRef<HTMLDivElement>(null);
  const wonChatRef = useRef<HTMLDivElement>(null);
  const dealsByYearRef = useRef<HTMLDivElement>(null);

  // Deals By Stage Chart
  useEffect(() => {
    if (chartRef.current && leadStats?.deal_summary) {
      const options = {
        series: [
          {
            name: "Deals",
            data: leadStats.deal_summary.map((deal) => ({
              x: deal.status || "Unknown",
              y: deal.deal_count,
            })),
          },
        ],
        chart: {
          type: "bar",
          height: 275,
        },
        plotOptions: {
          bar: {
            borderRadiusApplication: "around",
            columnWidth: "40%",
          },
        },
        colors: ["#00918E"],
        xaxis: {
          type: "category",
          group: {
            style: {
              fontSize: "7px",
              fontWeight: 700,
            },
          },
        },
        yaxis: {
          min: 0,
          max: Math.max(
            ...leadStats.deal_summary.map((d) => d.deal_count),
            100
          ),
          tickAmount: 5,
        },
      };

      const chart = new ApexCharts(chartRef.current, options);
      chart.render();
      return () => chart.destroy();
    }
  }, [leadStats]);

  // Leads By Stage Chart
  useEffect(() => {
    if (leadsByStageRef.current && leadStats?.lead_summary) {
      const options = {
        series: [
          {
            data: leadStats.lead_summary.map((s) => s.lead_count),
          },
        ],
        chart: {
          type: "bar",
          height: 150,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#FC0027"],
        xaxis: {
          categories: leadStats.lead_summary.map((s) => s.status),
          min: 0,
          max: Math.max(
            ...leadStats.lead_summary.map((s) => s.lead_count),
            100
          ),
          tickAmount: 5,
        },
      };

      const chart = new ApexCharts(leadsByStageRef.current, options);
      chart.render();
      return () => chart.destroy();
    }
  }, [leadStats]);

  // Won Deals Chart
  useEffect(() => {
    if (wonChatRef.current && leadStats?.deal_summary) {
      const wonDeals = leadStats.deal_summary.filter((d) =>
        ["Won", "WON", "won"].includes(d.status || "")
      );
      const options = {
        series: [
          {
            data: wonDeals.map((d) => d.deal_count),
          },
        ],
        chart: {
          type: "bar",
          height: 150,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: [theme.won],
        xaxis: {
          categories: wonDeals.map((d) => d.status || "Won"),
          min: 0,
          max: Math.max(...wonDeals.map((d) => d.deal_count), 100),
          tickAmount: 5,
        },
      };

      const chart = new ApexCharts(wonChatRef.current, options);
      chart.render();
      return () => chart.destroy();
    }
  }, [leadStats]);

  // Deals By Year
  useEffect(() => {
    if (dealsByYearRef.current && leadStats?.deal_summary) {
      const options = {
        series: [
          {
            name: "Deals",
            data: leadStats.deal_summary.map((d) => d.deal_count),
          },
        ],
        chart: {
          height: 273,
          type: "area",
          zoom: {
            enabled: false,
          },
        },
        colors: ["#E41F07"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        xaxis: {
          categories: leadStats.deal_summary.map((d) => d.status || "Unknown"),
        },
        yaxis: {
          min: 0,
          max: Math.max(
            ...leadStats.deal_summary.map((d) => d.deal_count),
            100
          ),
          tickAmount: 5,
          labels: {
            formatter: (val: number) => val.toFixed(0),
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
        },
      };

      const chart = new ApexCharts(dealsByYearRef.current, options);
      chart.render();
      return () => chart.destroy();
    }
  }, [leadStats]);

  // Donut Chart (Leads by Source)
  const [donutChart, setDonutChart] = useState<any>({
    chart: {
      height: 350,
      type: "donut",
      toolbar: { show: false },
    },
    labels: [],
    series: [],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: { width: 200 },
          legend: { position: "bottom" },
        },
      },
    ],
  });

  const [donutDetails, setDonutDetails] = useState<
    { label: string; count: number }[]
  >([]);

  useEffect(() => {
    if (leadStats?.lead_source) {
      const sourceData = leadStats.lead_source;
      const labels = sourceData.map((s) => s.lead_source_name);
      const series = sourceData.map((s) => s.total_leads);
      const donutDetails = sourceData.map((s) => ({
        label: s.lead_source_name,
        count: s.total_leads,
      }));
      setDonutChart((prev: any) => ({
        ...prev,
        labels,
        series,
      }));
      setDonutDetails(donutDetails);
    }
  }, [leadStats]);

  const [radialChart, setRadialChart] = useState<any>({
    chart: {
      height: 350,
      type: "radialBar",
      toolbar: { show: false },
    },
    plotOptions: {
      radialBar: {
        dataLabels: {
          name: { fontSize: "22px" },
          value: { fontSize: "16px" },
          total: {
            show: true,
            label: "Total",
            formatter: function () {
              return 0;
            },
          },
        },
      },
    },
    series: [],
    labels: [],
  });

  useEffect(() => {
    if (leadStats?.lead_summary) {
      const radialLabels = leadStats.lead_summary.map((s) => s.status);
      const radialSeries = leadStats.lead_summary.map((s) => s.lead_count);
      const totalLeads = radialSeries.reduce((sum, val) => sum + val, 0);
      setRadialChart((prev: any) => ({
        ...prev,
        labels: radialLabels,
        series: radialSeries,
        plotOptions: {
          ...prev.plotOptions,
          radialBar: {
            ...prev.plotOptions.radialBar,
            dataLabels: {
              ...prev.plotOptions.radialBar.dataLabels,
              total: {
                ...prev.plotOptions.radialBar.dataLabels.total,
                formatter: function () {
                  return totalLeads;
                },
              },
            },
          },
        },
      }));
    }
  }, [leadStats]);

  const statusWidgets = useMemo(
    () =>
      leadStats?.lead_summary
        ? [
          {
            label: "Contacted",
            value:
              leadStats.lead_summary.find((s) => s.status === "Contacted")
                ?.lead_count || 0,
            subtext: "Contacted leads",
            color: "bg-warning-subtle",
            icon: <FaPhone className="fs-3 text-warning" />,
          },
          {
            label: "Not Contacted",
            value:
              leadStats.lead_summary.find((s) => s.status === "Not_Contacted")
                ?.lead_count || 0,
            subtext: "Not Contacted leads",
            color: "bg-info-subtle",
            icon: <FaUserSlash className="fs-3 text-info" />,
          },
          {
            label: "Closed",
            value:
              leadStats.lead_summary.find((s) => s.status === "Closed")
                ?.lead_count || 0,
            subtext: "Closed leads",
            color: "bg-success-subtle",
            icon: <FaCheckCircle className="fs-3 text-success" />,
          },
          {
            label: "Lost",
            value:
              leadStats.lead_summary.find((s) => s.status === "Lost")
                ?.lead_count || 0,
            subtext: "Lost Leads",
            color: "bg-danger-subtle",
            icon: <FiTrendingDown className="fs-3 text-danger" />,
          },
        ]
        : [],
    [leadStats]
  );

  useEffect(() => {
    if (leadStats?.todo) {
      const allTodos = [
        ...(leadStats.todo.flatMap((t) => t.created_own) || []),
        ...(leadStats.todo.flatMap((t) => t.assigned_todo) || []),
      ];
      const sortedTodos = allTodos
        .sort(
          (a, b) =>
            moment(b.created_at).valueOf() - moment(a.created_at).valueOf()
        )
        .slice(0, 10);
      setTodos(sortedTodos);
    }
  }, [leadStats]);

  const handleOpenTodo = (todo: TodoItem) => {
    setSelectedTodo(todo);
    setShowTodoModal(true);
  };

  const handleCloseTodo = () => {
    setShowTodoModal(false);
    setSelectedTodo(null);
  };

  const renderPieData = () => {
    if (!leadStats) return [];
    const typeCount = leadStats.lead_type.reduce((acc, type) => {
      acc[type.lead_type_name.toLowerCase()] = type.total_leads;
      return acc;
    }, {} as Record<string, number>);
    return leadStats.lead_type.map((type) => ({
      name: type.lead_type_name.toLowerCase(),
      value: typeCount[type.lead_type_name.toLowerCase()] || 0,
    }));
  };

  const filteredLeads = leads.filter((lead) => {
    if (!lead.created_at) return false;

    const leadDate = new Date(lead.created_at);
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - filterDays);

    return leadDate >= cutoff;
  });

  const getRandomNoteColor = (index: number) =>
    noteColors[index % noteColors.length];

  return (
    <>
      <PageLoadProgressBar />
      <div className="scroll-progress-container">
        <div
          className="scroll-progress-bar"
          style={{ width: `${scrollProgress}%` }}
        ></div>
      </div>
      {showLoader && <div className="loader">Loading...</div>}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-md-4">
                    <h3 className="page-title fw-bold d-flex">
                      <i className="ti ti-layout-dashboard text-primary me-2" />
                      User Dashboard Overview
                    </h3>
                  </div>
                  <div className="col-md-8 float-end ms-auto">
                    <div className="d-flex title-head">
                      <div className="daterange-picker d-flex align-items-center justify-content-center">
                        <div className="head-icons mb-0">
                          <CollapseHeader />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {/* Daily Target Overview Section */}
            {/* Daily Target Overview Section */}
            {leadStats?.calculate_user_incentive && (
              <div className="col-md-12 fade-in">
                <div className="card border-0 shadow-sm mb-3 dashboard-card rounded-4">
                  {/* HEADER */}
                  <div className="card-header border-0 d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5 className="card-title mb-0 d-flex align-items-center gap-2">
                      <span
                        className="icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle"
                        style={{
                          width: 36,
                          height: 36,
                          background:
                            "linear-gradient(135deg, rgba(228,31,7,0.1), rgba(14,159,110,0.1))",
                        }}
                      >
                        <i className="ti ti-stairs-up  text-primary" />
                      </span>
                      <span>Target Overview</span>
                      <Tip
                        text="Track your target, incentive progress, and total deal value for the selected period."
                        placement="top"
                      >
                        <i
                          className="fa fa-info-circle text-primary"
                          style={{ cursor: "pointer", fontSize: 16 }}
                        />
                      </Tip>

                    </h5>

                    {/* Small pill with context (uses your headerLabel) */}
                    <span className="badge rounded-pill bg-light text-muted fw-semibold">
                      <i className="ti ti-calendar-stats me-1" />
                      {headerLabel}
                    </span>
                  </div>

                  <div className="card-body">
                    {/* 👋 Welcome Message */}
                    <h2 className="metric-value mb-1">
                      Welcome back,&nbsp;
                      <span className="text-primary">
                        {leadStats?.user_name
                          ? leadStats.user_name.charAt(0).toUpperCase() +
                          leadStats.user_name.slice(1)
                          : "User"}
                      </span>
                      !
                    </h2>
                    <p className="text-muted mb-3">{headerSubText}</p>

                    {/* QUICK STATS ROW */}
                    <div className="row g-3 mb-3">
                      <div className="col-6 col-md-3">
                        <div className="p-2 rounded-3 bg-light d-flex flex-column">
                          <span className="text-muted small d-flex align-items-center gap-1">
                            <i className="ti ti-currency-rupee text-secondary" />
                            Salary
                          </span>
                          <span className="fw-semibold">
                            ₹{salary.toLocaleString("en-IN")}
                          </span>
                        </div>
                      </div>
                      <div className="col-6 col-md-3">
                        <div className="p-2 rounded-3 bg-light d-flex flex-column">
                          <span className="text-muted small d-flex align-items-center gap-1">
                            <i className="ti ti-flag-3 text-primary" />
                            Target
                          </span>
                          <span className="fw-semibold text-primary">
                            ₹{targets.toLocaleString("en-IN")}
                          </span>
                        </div>
                      </div>
                      <div className="col-6 col-md-3">
                        <div className="p-2 rounded-3 bg-light d-flex flex-column">
                          <span className="text-muted small d-flex align-items-center gap-1">
                            <i className="ti ti-gift-card text-purple" />
                            Incentive Target
                          </span>
                          <span className="fw-semibold text-purple">
                            ₹{incentiveTarget.toLocaleString("en-IN")}
                          </span>
                        </div>
                      </div>
                      <div className="col-6 col-md-3">
                        <div className="p-2 rounded-3 bg-light d-flex flex-column">
                          <span className="text-muted small d-flex align-items-center gap-1">
                            <i className="ti ti-box text-success" />
                            Closed Deal Value
                          </span>
                          <span className="fw-semibold text-success">
                            ₹{dealValue.toLocaleString("en-IN")}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* 🔄 PROGRESS PHASES */}
                    {!isTargetAchieved ? (
                      <>
                        {/* Phase 1: Progress to Target */}
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span className="small fw-semibold text-muted">
                            Deal Progress to Target
                          </span>
                          <span className="small text-muted">
                            ₹{dealValue.toLocaleString("en-IN")} / ₹
                            {targets.toLocaleString("en-IN")}
                          </span>
                        </div>

                        <div
                          className="progress"
                          style={progressContainerStyle}
                        >
                          <AntdTooltip
                            title={`Achieved: ₹${dealValue.toLocaleString(
                              "en-IN"
                            )}`}
                          >
                            <span
                              style={{
                                ...progressSegmentStyle,
                                width: getSegmentWidth(dealValue, targets),
                                background:
                                  "linear-gradient(90deg, #03A9F4, #0288D1)",
                              }}
                            />
                          </AntdTooltip>

                          <AntdTooltip
                            title={`Remaining: ₹${Math.max(
                              targets - dealValue,
                              0
                            ).toLocaleString("en-IN")}`}
                          >
                            <span
                              style={{
                                ...progressSegmentStyle,
                                width: getSegmentWidth(
                                  Math.max(targets - dealValue, 0),
                                  targets
                                ),
                                backgroundColor: "#CFD8DC",
                              }}
                            />
                          </AntdTooltip>
                        </div>
                      </>
                    ) : !isIncentiveAchieved ? (
                      <>
                        {/* Phase 2: Incentive In Progress */}
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span className="small fw-semibold text-muted">
                            Incentive Progress
                          </span>
                          <span className="small text-muted">
                            ₹{incentiveAchieved.toLocaleString("en-IN")} / ₹
                            {incentiveTarget.toLocaleString("en-IN")}
                          </span>
                        </div>

                        <div
                          className="progress"
                          style={progressContainerStyle}
                        >
                          <AntdTooltip
                            title={`Incentive Achieved: ₹${incentiveAchieved.toLocaleString(
                              "en-IN"
                            )}`}
                          >
                            <span
                              style={{
                                ...progressSegmentStyle,
                                width: getSegmentWidth(
                                  incentiveAchieved,
                                  incentiveTarget
                                ),
                                background:
                                  "linear-gradient(90deg, #8E24AA, #AB47BC)",
                              }}
                            />
                          </AntdTooltip>

                          <AntdTooltip
                            title={`Remaining Incentive: ₹${remainingIncentive.toLocaleString(
                              "en-IN"
                            )}`}
                          >
                            <span
                              style={{
                                ...progressSegmentStyle,
                                width: getSegmentWidth(
                                  remainingIncentive,
                                  incentiveTarget
                                ),
                                backgroundColor: "#E1BEE7",
                              }}
                            />
                          </AntdTooltip>
                        </div>

                        <p className="mt-2 fw-semibold text-purple mb-0">
                          🎯 Incentive Progress: ₹
                          {incentiveAchieved.toLocaleString("en-IN")} of ₹
                          {incentiveTarget.toLocaleString("en-IN")} (
                          {incentivePercentage}%)
                        </p>
                      </>
                    ) : (
                      <>
                        {/* Phase 3: All Achieved */}
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span className="small fw-semibold text-muted">
                            All Targets Achieved
                          </span>
                          <span className="badge bg-success-subtle text-success fw-semibold">
                            100% Complete
                          </span>
                        </div>

                        <div
                          className="progress"
                          style={progressContainerStyle}
                        >
                          <span
                            style={{
                              ...progressSegmentStyle,
                              width: "100%",
                              background:
                                "linear-gradient(90deg, #4CAF50, #2E7D32)",
                            }}
                          />
                        </div>

                        <div
                          className="mt-3 alert alert-success fade-in mb-0"
                          role="alert"
                        >
                          <strong>🎉 All Targets Achieved!</strong>
                          <ul className="mb-0 mt-2 small">
                            <li>
                              🎯 <strong>Target:</strong> ₹
                              {targets.toLocaleString("en-IN")}
                            </li>
                            <li>
                              💸 <strong>Incentive Target:</strong> ₹
                              {incentiveTarget.toLocaleString("en-IN")}
                            </li>
                            <li>
                              💰 <strong>Deal Value:</strong> ₹
                              {dealValue.toLocaleString("en-IN")}
                            </li>
                            <li>
                              🏆 <strong>Incentive Earned:</strong> ₹
                              {calculatedIncentive.toLocaleString("en-IN")} (
                              {incentivePercentage}%)
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* End of Daily Target Overview Section */}
            {/* Status Widgets */}
            <div className="row g-3 mb-3">
              {statusWidgets.map((widget, index) => {
                const statusMap: Record<string, string> = {
                  "Contacted leads": "Contacted",
                  "Not Contacted leads": "Not_Contacted",
                  "Closed leads": "Closed",
                  "Lost Leads": "Lost",
                };

                const mappedStatus = statusMap[widget.subtext] || "";

                // Extract logical color name from widget.color ("bg-warning-subtle" → "warning")
                const colorKey = (widget.color || "")
                  .replace("bg-", "")
                  .replace("-subtle", "")
                  .replace("-card", "")
                  .trim()
                  .toLowerCase();

                const cardColors: Record<string, any> = {
                  warning: {
                    bg: "linear-gradient(135deg, #FFF8E1, #FFECB3)",
                    iconColor: "#F9A825",
                  },
                  info: {
                    bg: "linear-gradient(135deg, #E0F7FA, #B2EBF2)",
                    iconColor: "#0288D1",
                  },
                  success: {
                    bg: "linear-gradient(135deg, #E8F5E9, #C8E6C9)",
                    iconColor: "#2E7D32",
                  },
                  danger: {
                    bg: "linear-gradient(135deg, #FFEBEE, #FFCDD2)",
                    iconColor: "#C62828",
                  },
                };

                // FINAL COLOR (fallback = info)
                const colors = cardColors[colorKey] || cardColors.info;

                const totalLeads =
                  leadStats?.lead_summary?.reduce(
                    (sum, item) => sum + Number(item.lead_count || 0),
                    0
                  ) || 0;

                const widgetValue = Number(widget.value || 0);

                const percent =
                  totalLeads > 0
                    ? ((widgetValue / totalLeads) * 100).toFixed(1)
                    : "0.0";

                return (
                  <div className="col-6 col-md-3" key={index}>
                    <div
                      role="button"
                      tabIndex={0}
                      className="card shadow-sm dashboard-card rounded-4 widget-card"
                      style={{
                        cursor: "pointer",
                        background: colors.bg,
                        border: "none",
                        transition: "all 0.25s ease",
                      }}
                      onClick={() => {
                        if (mappedStatus && currentUserName) {
                          navigate(
                            `/leads?status=${mappedStatus}&owner=${encodeURIComponent(
                              currentUserName
                            )}`
                          );
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          if (mappedStatus && currentUserName) {
                            navigate(
                              `/leads?status=${mappedStatus}&owner=${encodeURIComponent(
                                currentUserName
                              )}`
                            );
                          }
                        }
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.03)";
                        e.currentTarget.style.boxShadow =
                          "0 6px 16px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 2px 6px rgba(0,0,0,0.08)";
                      }}
                    >
                      <div className="card-body text-center">
                        {/* ICON WRAPPER */}
                        <div
                          className="d-inline-flex align-items-center justify-content-center rounded-circle mb-2"
                          style={{
                            width: "58px",
                            height: "58px",
                            background: "#fff",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                            color: colors.iconColor,
                            fontSize: "30px",
                          }}
                        >
                          {widget.icon}
                        </div>

                        {/* VALUE */}
                        <h3 className="metric-value mb-1">{widget.value}</h3>

                        {/* SUBTEXT + TOOLTIP WITH % */}
                        <p className="metric-subtitle text-muted mb-0 d-flex align-items-center justify-content-center gap-1">
                          {widget.subtext}

                          <Tip
                            text={`${widget.subtext}: ${widgetValue} leads (${percent}%)`}
                            placement="top"
                          >
                            <i
                              className="fa fa-info-circle text-primary small"
                              style={{ cursor: "pointer" }}
                            />
                          </Tip>
                        </p>

                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="col-md-12">
              <div className="row g-2">
                {/* ====================== RECENTLY CREATED LEADS ====================== */}
                <div className="col-md-6 d-flex fade-in">
                  <div className="card flex-fill shadow-sm border-0 rounded-4">
                    <div className="card-header border-0 d-flex justify-content-between align-items-center">
                      <h4 className="fw-bold mb-0 d-flex align-items-center gap-2">
                        <i className="ti ti-briefcase-2 text-primary"></i>
                        Recently Created Leads
                        <Tip
                          text="Shows the most recently added leads within the selected timeframe."
                          placement="top"
                        >
                          <i
                            className="fa fa-info-circle text-primary ms-1"
                            style={{ cursor: "pointer" }}
                          />
                        </Tip>

                      </h4>

                      {/* Filter dropdown */}
                      <div className="dropdown">
                        <span
                          className="dropdown-toggle fw-semibold"
                          data-bs-toggle="dropdown"
                          style={{ cursor: "pointer" }}
                        >
                          <i className="ti ti-calendar-check me-1"></i>
                          Last {filterDays} days
                        </span>

                        <div className="dropdown-menu dropdown-menu-end">
                          {[7, 15, 30].map((d) => (
                            <button
                              key={d}
                              className="dropdown-item"
                              onClick={() => setFilterDays(d)}
                            >
                              Last {d} days
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Table */}
                    <div className="card-body pt-2">
                      <div
                        className="table-responsive"
                        style={{ maxHeight: "300px", overflowY: "auto" }}
                      >
                        <table className="table align-middle table-hover">
                          <thead className="table-light">
                            <tr>
                              <th>Lead Name</th>
                              <th>Stage</th>
                              <th>Value</th>
                              <th>Industry</th>
                              <th>Owner</th>
                              <th>Status</th>
                            </tr>
                          </thead>

                          <tbody>
                            {filteredLeads.slice(0, 5).map((lead, i) => {
                              const bgHover = "rgba(0,0,0,0.04)";

                              return (
                                <tr
                                  key={lead.lead_id}
                                  style={{
                                    cursor: "pointer",
                                    transition: "0.2s",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.background = bgHover)
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.background = "")
                                  }
                                  onClick={() => {
                                    if (!currentUserName) return;
                                    navigate(
                                      `/leads?owner=${encodeURIComponent(
                                        currentUserName
                                      )}&lead_id=${lead.lead_id}`
                                    );
                                  }}
                                >
                                  <td>
                                    <strong>
                                      {lead?.contact?.contact_person_name ||
                                        "N/A"}
                                    </strong>
                                    <br />
                                    <small className="text-muted">
                                      {lead?.contact?.company_name}
                                    </small>
                                  </td>

                                  <td>
                                    {lead?.leadstage?.LeadStage_name || "N/A"}
                                  </td>

                                  <td>
                                    ₹
                                    {Number(
                                      lead?.lead_value || 0
                                    ).toLocaleString()}
                                  </td>

                                  <td>
                                    {lead?.leadindustry?.LeadIndustry_name ||
                                      "N/A"}
                                  </td>

                                  <td>{lead?.users?.name || "N/A"}</td>

                                  <td>
                                    <span
                                      className={`badge px-3 py-2 rounded-pill shadow-sm ${{
                                        contacted: "bg-success",
                                        "not contacted":
                                          "bg-warning text-dark",
                                        closed: "bg-primary",
                                        lost: "bg-danger",
                                      }[lead?.lead_status?.toLowerCase()] ||
                                        "bg-secondary"
                                        }`}
                                    >
                                      {lead?.lead_status || "N/A"}
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>

                        {filteredLeads.length === 0 && (
                          <div className="text-center text-muted py-3">
                            <i className="ti ti-database-off fs-2 mb-2" />
                            <p className="mb-0">
                              No leads found in the selected period.
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Deal Revenue by Status */}
                {/* ====================== DEAL REVENUE BY STATUS ====================== */}
                <div className="col-md-6 d-flex fade-in">
                  <div
                    className="card flex-fill shadow-sm border-0 rounded-4"
                    id="deal-revenue-status-card"
                    style={{
                      backdropFilter: "blur(4px)",
                      WebkitBackdropFilter: "blur(4px)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {/* ---- HEADER ---- */}
                    <div style={{ overflow: "visible" }} className="card-header border-0 pb-0 d-flex justify-content-between align-items-center">
                      <h4
                        className="fw-bold mb-2 d-flex align-items-center gap-2"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          currentUserName &&
                          navigate(
                            `/crm/deals?owner=${encodeURIComponent(
                              currentUserName
                            )}`
                          )
                        }
                      >
                        <i className="ti ti-chart-bar text-primary"></i>
                        Deal Revenue by Status
                        <Tip
                          text="This stacked chart shows revenue distribution across deal statuses: Won, Lost, Open, Closed."
                          placement="top"
                        >
                          <i
                            className="fa fa-info-circle text-primary ms-1"
                            style={{ cursor: "pointer", fontSize: 15 }}
                          />
                        </Tip>

                      </h4>
                      <div className="d-flex gap-1 flex-shrink-0 align-items-center">
                        <ChartExportControl
                          variant="dots"
                          data={dealRevenueData?.map((item: any) => ({
                            name: item.name,
                            Won: item.won ?? 0,
                            Lost: item.Lost ?? 0,
                            Open: item.Open ?? 0,
                            Closed: item.Closed ?? 0,
                          })) ?? []}
                          filename="Deal_Revenue_by_Status"
                          cardId="deal-revenue-status-card"
                        />
                      </div>
                    </div>

                    {/* ---- BODY ---- */}
                    <div className="card-body">
                      {dealRevenueData.length > 0 ? (
                        <div style={{ width: "100%", height: 310 }}>
                          <ResponsiveContainer width="100%" height="100%">
                            <BarChart
                              data={dealRevenueData}
                              margin={{
                                top: 20,
                                right: 25,
                                left: 5,
                                bottom: 10,
                              }}
                            >
                              {/* GRID */}
                              <CartesianGrid
                                strokeDasharray="3 3"
                                opacity={0.25}
                              />

                              {/* AXES */}
                              <XAxis
                                dataKey="name"
                                tick={{ fontSize: 12, fill: "#555" }}
                                axisLine={false}
                                tickLine={false}
                              />
                              <YAxis
                                tick={{ fontSize: 12, fill: "#555" }}
                                axisLine={false}
                                tickLine={false}
                              />

                              {/* TOOLTIP */}
                              <Tooltip
                                formatter={(val, name) => [
                                  `₹${Number(val).toLocaleString()}`,
                                  name,
                                ]}
                                contentStyle={{
                                  borderRadius: "10px",
                                  border: "none",
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                }}
                              />

                              {/* CUSTOM LEGEND */}
                              <Legend
                                formatter={(value) => (
                                  <span
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {value}
                                  </span>
                                )}
                                verticalAlign="top"
                                height={30}
                              />

                              {/* --- GRADIENT DEFINITIONS --- */}
                              <defs>
                                <linearGradient
                                  id="wonGrad"
                                  x1="0"
                                  y1="0"
                                  x2="0"
                                  y2="1"
                                >
                                  <stop
                                    offset="0%"
                                    stopColor={theme.won}
                                    stopOpacity={0.85}
                                  />
                                  <stop
                                    offset="100%"
                                    stopColor={theme.won}
                                    stopOpacity={0.55}
                                  />
                                </linearGradient>

                                <linearGradient
                                  id="lostGrad"
                                  x1="0"
                                  y1="0"
                                  x2="0"
                                  y2="1"
                                >
                                  <stop
                                    offset="0%"
                                    stopColor={theme.lost}
                                    stopOpacity={0.85}
                                  />
                                  <stop
                                    offset="100%"
                                    stopColor={theme.lost}
                                    stopOpacity={0.55}
                                  />
                                </linearGradient>

                                <linearGradient
                                  id="openGrad"
                                  x1="0"
                                  y1="0"
                                  x2="0"
                                  y2="1"
                                >
                                  <stop
                                    offset="0%"
                                    stopColor={theme.open}
                                    stopOpacity={0.85}
                                  />
                                  <stop
                                    offset="100%"
                                    stopColor={theme.open}
                                    stopOpacity={0.55}
                                  />
                                </linearGradient>

                                <linearGradient
                                  id="closedGrad"
                                  x1="0"
                                  y1="0"
                                  x2="0"
                                  y2="1"
                                >
                                  <stop
                                    offset="0%"
                                    stopColor={theme.closed}
                                    stopOpacity={0.85}
                                  />
                                  <stop
                                    offset="100%"
                                    stopColor={theme.closed}
                                    stopOpacity={0.55}
                                  />
                                </linearGradient>
                              </defs>

                              {/* ---- BARS WITH ANIMATIONS + CLICK ---- */}
                              {[
                                {
                                  key: "won",
                                  label: "Won",
                                  color: "url(#wonGrad)",
                                },
                                {
                                  key: "Lost",
                                  label: "Lost",
                                  color: "url(#lostGrad)",
                                },
                                {
                                  key: "Open",
                                  label: "Open",
                                  color: "url(#openGrad)",
                                },
                                {
                                  key: "Closed",
                                  label: "Closed",
                                  color: "url(#closedGrad)",
                                },
                              ].map((item) => (
                                <Bar
                                  key={item.key}
                                  dataKey={item.key}
                                  name={item.label}
                                  stackId="stack"
                                  fill={item.color}
                                  radius={[6, 6, 0, 0]}
                                  animationDuration={900}
                                  cursor="pointer"
                                  onClick={() =>
                                    currentUserName &&
                                    navigate(
                                      `/crm/deals?status=${item.key
                                      }&owner=${encodeURIComponent(
                                        currentUserName
                                      )}`
                                    )
                                  }
                                />
                              ))}
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      ) : (
                        <div className="text-center text-muted py-3">
                          <i className="ti ti-chart-bar-off fs-2 mb-2" />
                          <p className="mb-0">
                            No deal revenue data available
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row g-2">
              {/* Conversion Rate */}
              <div className="col-md-6 col-lg-3 fade-in d-flex">
                <div
                  className="card text-center shadow-sm dashboard-card flex-fill border-0 rounded-4"
                  style={{
                    background: "linear-gradient(145deg, #ffffff, #f3f8ff)",
                    transition: "all 0.28s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.03)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 20px rgba(0,0,0,0.12)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(0,0,0,0.08)";
                  }}
                >
                  {/* ---- HEADER ---- */}
                  <div className="card-header border-0 bg-transparent">
                    <h5 className="card-title mb-0 d-flex align-items-center justify-content-center gap-2">
                      <span className="icon-wrapper">
                        <i className="ti ti-chart-infographic text-primary"></i>
                      </span>
                      Conversion Rate
                      <Tip
                        text="This radial gauge shows your Lead → Deal conversion percentage."
                        placement="top"
                      >
                        <i
                          className="fa fa-info-circle text-primary small"
                          style={{ cursor: "pointer" }}
                        />
                      </Tip>

                    </h5>
                  </div>

                  {/* ---- BODY ---- */}
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    {leadStats?.conversion_rate &&
                      !isNaN(leadStats.conversion_rate.conversion_rate_percent) &&
                      leadStats.conversion_rate.conversion_rate_percent >= 0 ? (
                      <>
                        <div
                          style={{ height: "190px" }}
                          className="d-flex justify-content-center"
                        >
                          <ReactApexChart
                            options={{
                              chart: {
                                type: "radialBar",
                                sparkline: { enabled: true },
                                animations: {
                                  enabled: true,
                                  speed: 900, // ⬅ valid
                                  animateGradually: {
                                    enabled: true,
                                    delay: 150,
                                  },
                                  dynamicAnimation: {
                                    enabled: true,
                                    speed: 300,
                                  },
                                },
                              },

                              fill: {
                                type: "gradient",
                                gradient: {
                                  shade: "light",
                                  type: "vertical",
                                  gradientToColors: [theme.closed],
                                  stops: [0, 100],
                                },
                              },

                              plotOptions: {
                                radialBar: {
                                  hollow: { size: "58%" },
                                  track: {
                                    background: "#ECEFF1",
                                    strokeWidth: "90%",
                                    opacity: 0.65,
                                  },
                                  dataLabels: {
                                    name: { show: false },
                                    value: {
                                      fontSize: "26px",
                                      fontWeight: "700",
                                      color: theme.closed,
                                      offsetY: 4,
                                      formatter: (v) => `${v.toFixed(1)}%`,
                                    },
                                  },
                                },
                              },

                              stroke: {
                                lineCap: "round", // ⬅ outside plotOptions (correct)
                              },

                              colors: [theme.closed],
                            }}
                            series={[
                              leadStats.conversion_rate.conversion_rate_percent,
                            ]}
                            type="radialBar"
                            height={190}
                          />
                        </div>

                        {/* LABEL */}
                        <h6 className="metric-subtitle text-muted mt-2">
                          Lead → Deal Conversion
                        </h6>

                        {/* VALUE */}
                        <h3
                          className="metric-value"
                          style={{ color: theme.closed, fontWeight: 700 }}
                        >
                          {leadStats.conversion_rate.conversion_rate_percent.toFixed(
                            1
                          )}
                          %
                        </h3>
                      </>
                    ) : (
                      <p className="metric-subtitle mb-0 text-muted">
                        No conversion data available
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* User Target */}
              <div className="col-md-6 col-lg-3 fade-in d-flex">
                <div
                  className="card text-center shadow-sm border-0 dashboard-card flex-fill rounded-4"
                  style={{
                    background: "linear-gradient(135deg, #E3F2FD, #BBDEFB)",
                    transition: "all 0.25s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.03)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 20px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 3px 10px rgba(0,0,0,0.08)";
                  }}
                >
                  {/* Header */}
                  <div className="card-header bg-transparent border-0 pb-0">
                    <h5 className="card-title mb-0 d-flex justify-content-center align-items-center gap-2">
                      <span className="icon-wrapper">
                        <i className="ti ti-report-money text-primary"></i>
                      </span>
                      User Target
                      <Tip
                        text="Deal value progress towards user target."
                        placement="top"
                      >
                        <i
                          className="fa fa-info-circle text-primary small"
                          style={{ cursor: "pointer" }}
                        />
                      </Tip>

                    </h5>
                  </div>

                  {/* Body */}
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    {incentive?.target ? (
                      <>
                        {/* Chart */}
                        <div style={{ height: "180px" }}>
                          <ResponsiveContainer width="100%" height={180}>
                            <BarChart
                              data={[
                                {
                                  name: "Progress",
                                  value: incentive.total_deal_value,
                                  target: incentive.target,
                                },
                              ]}
                              margin={{
                                top: 10,
                                right: 20,
                                left: 20,
                                bottom: 10,
                              }}
                            >
                              <CartesianGrid
                                strokeDasharray="4 4"
                                opacity={0.4}
                              />
                              <XAxis dataKey="name" hide />
                              <YAxis
                                domain={[0, incentive.target * 1.2]}
                                hide
                              />

                              <Tooltip
                                formatter={(val: number) =>
                                  `₹${Number(val).toLocaleString("en-IN")}`
                                }
                                labelFormatter={() => "User Target Progress"}
                                contentStyle={{
                                  borderRadius: 10,
                                  border: "none",
                                  boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                                }}
                              />

                              <Bar
                                dataKey="value"
                                fill="#1976D2"
                                radius={[8, 8, 0, 0]}
                                animationDuration={900}
                              />

                              {/* Target Reference Line */}
                              <ReferenceLine
                                y={incentive.target}
                                stroke="#0D47A1"
                                strokeDasharray="5 3"
                                strokeWidth={2}
                                label={{
                                  position: "right",
                                  value: "Target",
                                  fill: "#0D47A1",
                                  fontSize: 12,
                                }}
                              />
                            </BarChart>
                          </ResponsiveContainer>
                        </div>

                        {/* Target Display */}
                        <h4 className="metric-value text-primary mt-2">
                          ₹{incentive.target.toLocaleString("en-IN")}
                        </h4>

                        {/* Status */}
                        {incentive.total_deal_value >= incentive.target ? (
                          <p className="mt-2 text-success fw-semibold metric-subtitle d-flex align-items-center justify-content-center gap-1">
                            <FaCheckCircle /> Target Achieved!
                          </p>
                        ) : (
                          <p className="mt-2 text-warning fw-semibold metric-subtitle d-flex align-items-center justify-content-center gap-1">
                            <FiTrendingDown />₹
                            {(
                              incentive.target - incentive.total_deal_value
                            ).toLocaleString("en-IN")}{" "}
                            to go (
                            {incentive.target > 0
                              ? Math.round(
                                (incentive.total_deal_value /
                                  incentive.target) *
                                100
                              )
                              : 0}
                            %)
                          </p>
                        )}
                      </>
                    ) : (
                      <p className="metric-subtitle mb-0 text-muted">
                        No target set. Contact admin.
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Incentive Overview */}
              <div className="col-md-6 col-lg-3 fade-in d-flex">
                <div
                  className="card text-center shadow-sm dashboard-card flex-fill rounded-4"
                  style={{
                    background: "linear-gradient(135deg, #E1F5FE, #B3E5FC)",
                    border: "none",
                    transition: "all 0.25s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.03)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 20px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 6px rgba(0,0,0,0.08)";
                  }}
                >
                  {/* Header */}
                  <div className="card-header bg-transparent border-0 pb-0">
                    <h5 className="card-title mb-0 d-flex justify-content-center align-items-center gap-2">
                      <span className="icon-wrapper">
                        <i className="ti ti-cash text-info" />
                      </span>
                      Incentive Overview
                      <Tip
                        text="Based on total deal value and incentive percentage."
                        placement="top"
                      >
                        <i
                          className="fa fa-info-circle text-primary small"
                          style={{ cursor: "pointer" }}
                        />
                      </Tip>

                    </h5>
                  </div>

                  {/* Body */}
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    {isIncentiveLoading ? (
                      <p className="metric-subtitle mb-0 text-muted">
                        Loading incentive data...
                      </p>
                    ) : incentive ? (
                      <>
                        {/* Radial Chart */}
                        <div style={{ height: "180px" }}>
                          <ReactApexChart
                            options={{
                              chart: { type: "radialBar", height: 180 },
                              plotOptions: {
                                radialBar: {
                                  hollow: { size: "60%" },
                                  track: {
                                    background: "#E0F7FA",
                                  },
                                  dataLabels: {
                                    show: true,
                                    name: { show: false },
                                    value: {
                                      fontSize: "26px",
                                      fontWeight: 700,
                                      color: "#0288D1",
                                      offsetY: 0,
                                      formatter: (val) =>
                                        `${Number(val).toFixed(0)}%`,
                                    },
                                  },
                                },
                              },
                              fill: {
                                type: "gradient",
                                gradient: {
                                  shade: "light",
                                  type: "vertical",
                                  gradientToColors: ["#01579B"],
                                  stops: [0, 90],
                                },
                              },
                              colors: ["#0288D1"],
                            }}
                            series={[
                              Number(incentive.incentive_percentage || 0),
                            ]}
                            type="radialBar"
                            height={180}
                          />
                        </div>

                        {/* Incentive Amount */}
                        <h3 className="metric-value text-info mt-2">
                          {incentive.calculated_incentive.toLocaleString(
                            "en-IN",
                            {
                              style: "currency",
                              currency: "INR",
                              minimumFractionDigits: 0,
                            }
                          )}
                        </h3>

                        {/* Description */}
                        <p className="metric-subtitle mb-0 text-muted">
                          Incentive at <b>{incentive.incentive_percentage}%</b>
                          for{" "}
                          <b>
                            {incentive.total_deal_value.toLocaleString(
                              "en-IN",
                              {
                                style: "currency",
                                currency: "INR",
                                minimumFractionDigits: 0,
                              }
                            )}
                          </b>{" "}
                          total deals
                        </p>
                      </>
                    ) : (
                      <p className="metric-subtitle mb-0 text-muted">
                        No incentive data available. Contact admin.
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Total Deal Value */}
              <div className="col-md-6 col-lg-3 fade-in d-flex">
                <div
                  className="card text-center shadow-sm dashboard-card flex-fill rounded-4"
                  style={{
                    background: "linear-gradient(135deg, #FFF3E0, #FFE0B2)",
                    border: "none",
                    transition: "all 0.25s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.03)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 20px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 6px rgba(0,0,0,0.08)";
                  }}
                >
                  {/* Header */}
                  <div className="card-header bg-transparent border-0 pb-0">
                    <h5 className="card-title mb-0 d-flex justify-content-center align-items-center gap-2">
                      <span className="icon-wrapper d-inline-flex align-items-center justify-content-center">
                        <i className="ti ti-coin-rupee text-warning"></i>
                      </span>
                      Total Deal Value
                      <Tip
                        text="Total revenue value of all deals you have created."
                        placement="top"
                      >
                        <i
                          className="fa fa-info-circle text-primary small"
                          style={{ cursor: "pointer" }}
                        />
                      </Tip>

                    </h5>
                  </div>

                  {/* Body */}
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    {leadStats?.deal_summary &&
                      leadStats.deal_summary.length > 0 ? (
                      <>
                        {(() => {
                          // ✔️ Performance: compute total only once
                          const totalValue = leadStats?.deal_summary.reduce(
                            (sum, d) => sum + (d.total_value || 0),
                            0
                          );

                          return (
                            <>
                              {/* Area Chart */}
                              <div style={{ height: "180px" }}>
                                <ResponsiveContainer width="100%" height={180}>
                                  <AreaChart
                                    data={[
                                      {
                                        name: "Total Deals",
                                        value: totalValue,
                                      },
                                    ]}
                                    margin={{
                                      top: 15,
                                      right: 15,
                                      left: 15,
                                      bottom: 15,
                                    }}
                                  >
                                    <defs>
                                      <linearGradient
                                        id="dealGradient"
                                        x1="0"
                                        y1="0"
                                        x2="0"
                                        y2="1"
                                      >
                                        <stop
                                          offset="5%"
                                          stopColor={theme.open}
                                          stopOpacity={0.85}
                                        />
                                        <stop
                                          offset="95%"
                                          stopColor={theme.open}
                                          stopOpacity={0.15}
                                        />
                                      </linearGradient>
                                    </defs>

                                    <XAxis dataKey="name" hide />
                                    <YAxis
                                      domain={[0, totalValue * 1.2]}
                                      hide
                                    />

                                    <Tooltip
                                      formatter={(value) =>
                                        value.toLocaleString("en-IN", {
                                          style: "currency",
                                          currency: "INR",
                                          minimumFractionDigits: 0,
                                        })
                                      }
                                      labelFormatter={() => "Total Deal Value"}
                                      contentStyle={{
                                        borderRadius: 10,
                                        border: "none",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                      }}
                                    />

                                    <Area
                                      type="monotone"
                                      dataKey="value"
                                      fill="url(#dealGradient)"
                                      stroke={theme.open}
                                      strokeWidth={2}
                                      animationDuration={900}
                                    />
                                  </AreaChart>
                                </ResponsiveContainer>
                              </div>

                              {/* Total Value */}
                              <h3 className="metric-value text-warning">
                                {totalValue.toLocaleString("en-IN", {
                                  style: "currency",
                                  currency: "INR",
                                  minimumFractionDigits: 0,
                                })}
                              </h3>

                              <p className="metric-subtitle mb-0">
                                Total value of all deals
                              </p>
                            </>
                          );
                        })()}
                      </>
                    ) : (
                      <p className="metric-subtitle mb-0 text-muted">
                        No deal data available
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-12 d-flex fade-in">
                <div
                  className="card flex-fill shadow-sm border-0 rounded-4 team-performance-card"
                  id="team-performance-tracker-card"
                  style={{
                    background: "linear-gradient(135deg, #F8FAFF, #FFFFFF)",
                    transition: "all 0.25s ease",
                  }}
                >
                  {/* HEADER */}
                  <div style={{ overflow: "visible" }} className="card-header pb-2 d-flex justify-content-between align-items-center flex-wrap border-0 bg-transparent">
                    <h5 className="fw-bold mb-2 d-flex align-items-center gap-2">
                      <i className="ti ti-arrows-left-right text-primary"></i>
                      Team Performance Tracker
                      <Tip
                        text="Track each team member’s salary, target, incentive progress and deal performance."
                        placement="top"
                      >
                        <i
                          className="fa fa-info-circle text-primary small"
                          style={{ cursor: "pointer" }}
                        />
                      </Tip>

                    </h5>

                    <div className="d-flex gap-1 flex-shrink-0 align-items-center">
                      <ChartExportControl
                        variant="dots"
                        data={userNames?.map((name, i) => ({
                          User: name,
                          Salary: RevenueSeries[0]?.data?.[i] ?? 0,
                          Target: RevenueSeries[1]?.data?.[i] ?? 0,
                          "Incentive Target": RevenueSeries[2]?.data?.[i] ?? 0,
                          "Total Deal Value": RevenueSeries[3]?.data?.[i] ?? 0,
                          "Incentive %": RevenueSeries[4]?.data?.[i] ?? 0,
                          "Calculated Incentive": RevenueSeries[5]?.data?.[i] ?? 0,
                          "Incentive Achieved Amount": RevenueSeries[6]?.data?.[i] ?? 0,
                        })) ?? []}
                        filename="Team_Performance_Tracker"
                        cardId="team-performance-tracker-card"
                      />
                    </div>
                  </div>

                  {/* BODY */}
                  <div className="card-body">
                    {targetData.length === 0 ||
                      targetData.every(
                        (t) =>
                          !t.salary &&
                          !t.target &&
                          !t.incentive_target &&
                          !t.total_deal_value &&
                          !t.incentive_percentage &&
                          !t.calculated_incentive
                      ) ? (
                      <div className="text-center text-muted py-4">
                        <i className="fa fa-exclamation-triangle fs-2 me-2"></i>
                        <p className="mb-0">No target set yet.</p>
                      </div>
                    ) : (
                      <>
                        {/* =================== CHART =================== */}
                        <ReactApexChart
                          options={{
                            ...RevenueChart,
                            chart: {
                              ...RevenueChart.chart,
                              toolbar: { show: false },
                              animations: {
                                enabled: true,
                                speed: 900,
                              },
                            },
                            plotOptions: {
                              bar: {
                                horizontal: false,
                                borderRadius: 8,
                                barHeight: "60%",
                                columnWidth: "35%",
                                distributed: false,
                              },
                            },
                            tooltip: {
                              theme: "light",
                              y: {
                                formatter: (val: number) =>
                                  `₹${val.toLocaleString("en-IN")}`,
                              },
                            },
                            dataLabels: {
                              enabled: false,
                            },
                            xaxis: {
                              ...RevenueChart.xaxis,
                              labels: {
                                style: {
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  colors: "#666",
                                },
                              },
                            },
                            yaxis: {
                              labels: {
                                formatter: (val: number) =>
                                  `₹${val.toLocaleString("en-IN")}`,
                              },
                            },
                            legend: {
                              position: "top",
                              fontSize: "13px",
                              itemMargin: { horizontal: 10 },
                            },
                            fill: {
                              opacity: 0.9,
                              type: "gradient",
                              gradient: {
                                shade: "light",
                                type: "vertical",
                                shadeIntensity: 0.3,
                                opacityFrom: 0.9,
                                opacityTo: 0.7,
                                stops: [0, 90, 100],
                              },
                            },
                          }}
                          series={RevenueSeries}
                          type="bar"
                          height={330}
                        />

                        {/* =============== TOGGLE BUTTON =============== */}
                        <div className="mt-3">
                          <button
                            className="btn btn-link p-0 text-primary small fw-semibold"
                            onClick={() => setShowExplanation((prev) => !prev)}
                            style={{ textDecoration: "none" }}
                          >
                            {showExplanation
                              ? "Hide Explanation ▲"
                              : "Show Explanation ▼"}
                          </button>
                        </div>

                        {/* =============== EXPLANATION PANEL =============== */}
                        {showExplanation && (
                          <div
                            className="mt-3 p-3 rounded bg-light border small fade-in"
                            style={{
                              animation: "slideDown 0.3s ease",
                            }}
                          >
                            <div className="d-flex align-items-start mb-2">
                              <i className="fa fa-info-circle text-primary me-2 mt-1" />
                              <span>
                                <strong>Salary:</strong> Base monthly salary for
                                the user.
                              </span>
                            </div>

                            <div className="d-flex align-items-start mb-2">
                              <i className="fa fa-info-circle text-primary me-2 mt-1" />
                              <span>
                                <strong>Target:</strong> Expected revenue target
                                (e.g., 20× salary).
                              </span>
                            </div>

                            <div className="d-flex align-items-start mb-2">
                              <i className="fa fa-info-circle text-primary me-2 mt-1" />
                              <span>
                                <strong>Incentive Target:</strong> Additional
                                benchmark (e.g., 5× salary).
                              </span>
                            </div>

                            <div className="d-flex align-items-start mb-2">
                              <i className="fa fa-info-circle text-primary me-2 mt-1" />
                              <span>
                                If <strong>Target</strong> is achieved but{" "}
                                <strong>Incentive Target</strong> is not,
                                incentive = 2× achieved incentive.
                              </span>
                            </div>

                            <div className="d-flex align-items-start">
                              <i className="fa fa-info-circle text-primary me-2 mt-1" />
                              <span>
                                If <strong>both</strong> are achieved, incentive
                                = 5× incentive amount.
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div
                className="card shadow-sm border-0 rounded-4 mt-3 leaderboard-card fade-in"
                style={{
                  background: "linear-gradient(135deg, #F9FBFF, #FFFFFF)",
                  transition: "all 0.25s ease",
                }}
              >
                {/* ===================== HEADER ===================== */}
                <div
                  className="card-header border-0 py-3 d-flex justify-content-between align-items-center flex-wrap"
                  style={{ background: "transparent" }}
                >
                  <h5 className="fw-bold mb-2 d-flex align-items-center gap-2">
                    <i className="ti ti-medal text-primary "></i>
                    Top 5 Performers Leaderboard
                    <Tip
                      text="Displays top 5 users based on total incentive earned or deal value."
                      placement="top"
                    >
                      <i
                        className="fa fa-info-circle text-primary small"
                        style={{ cursor: "pointer" }}
                      />
                    </Tip>

                  </h5>

                  {/* FILTER */}
                  <div className="d-flex align-items-center gap-2">
                    <label className="small fw-semibold mb-0 text-muted">
                      Filter:
                    </label>
                    <select
                      className="form-select form-select-sm shadow-sm rounded-3"
                      style={{ width: "150px" }}
                      value={sortBy}
                      onChange={(e) =>
                        setSortBy(e.target.value as "all" | "2x" | "5x")
                      }
                    >
                      <option value="all">All Levels</option>
                      <option value="2x">2x Incentive</option>
                      <option value="5x">5x Incentive</option>
                    </select>
                  </div>
                </div>



                {/* ===================== TABLE ===================== */}
                {topPerformers.length === 0 ? (
                  /* ================= NO DATA STATE ================= */
                  <div className="d-flex flex-column align-items-center justify-content-center py-5 text-muted fade-in">
                    <div
                      className="text-center text-muted mb-3"
                    >
                      <i className="ti ti-table-off fs-1" />
                    </div>

                    <p className="mb-1">No Top Performers Yet</p>
                    <p className="small mb-0 text-center">
                      No users match the selected incentive filter.
                    </p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover table-borderless align-middle leaderboard-table mb-0">
                      <thead className="table-light sticky-top shadow-sm">
                        <tr>
                          <th className="fw-semibold small">Rank</th>
                          <th className="fw-semibold small">User</th>
                          <th className="fw-semibold small">Deal Value</th>
                          <th className="fw-semibold small">
                            Incentive Achieved
                          </th>
                          <th className="fw-semibold small">Incentive %</th>
                          <th className="fw-semibold small">Incentive Level</th>
                          <th className="fw-semibold small text-success">
                            Total Incentive
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {topPerformers.map((user, index) => {
                          // 🎖 Rank Icons
                          const rankIcon =
                            index === 0
                              ? "🥇"
                              : index === 1
                                ? "🥈"
                                : index === 2
                                  ? "🥉"
                                  : `#${index + 1}`;

                          return (
                            <tr
                              key={user.user_id}
                              className="leaderboard-row"
                              style={{
                                transition: "all 0.25s ease",
                                cursor: "pointer",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "#F3F6FF";
                                e.currentTarget.style.transform = "scale(1.01)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "transparent";
                                e.currentTarget.style.transform = "scale(1)";
                              }}
                            >
                              <td className="fw-bold text-primary">{rankIcon}</td>

                              <td className="fw-semibold">{user.user_name}</td>

                              <td className="text-dark">
                                ₹{user.total_deal_value?.toLocaleString() || 0}
                              </td>

                              <td className="text-info">
                                ₹
                                {user.incentive_achieved_amount?.toLocaleString() ||
                                  0}
                              </td>

                              <td className="fw-bold">
                                <span
                                  className={
                                    (user.incentive_percentage ?? 0) >= 50
                                      ? "text-success"
                                      : (user.incentive_percentage ?? 0) >= 25
                                        ? "text-warning"
                                        : "text-danger"
                                  }
                                >
                                  {user.incentive_percentage}%
                                </span>
                              </td>

                              <td>
                                <span
                                  className={`badge px-3 py-2 rounded-pill ${user.incentive_level?.includes("Fully")
                                    ? "bg-success-subtle text-success"
                                    : "bg-warning-subtle text-warning fw-semibold"
                                    }`}
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {user.incentive_level}
                                </span>
                              </td>

                              <td className="fw-bold text-success">
                                ₹
                                {user.calculated_incentive?.toLocaleString() || 0}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className="col-md-6 d-flex fade-in">
                <div className="card w-100 shadow-sm border-0 rounded-4" id="leads-funnel-overview-card">
                  {/* ================= Header ================= */}
                  <div style={{ overflow: "visible" }} className="card-header border-0 pb-0 d-flex justify-content-between align-items-center">
                    <h4
                      className="fw-bold mb-2 d-flex align-items-center gap-2"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        currentUserName &&
                        navigate(
                          `/leads?owner=${encodeURIComponent(currentUserName)}`
                        )
                      }
                    >
                      <i className="ti ti-stairs-down text-primary "></i>
                      Lead Funnel by Stage
                      <Tip
                        text="Shows how leads distribute across each stage in your funnel."
                        placement="top"
                      >
                        <i
                          className="fa fa-info-circle text-primary"
                          style={{ cursor: "pointer" }}
                        />
                      </Tip>
                    </h4>
                    <div className="d-flex gap-1 flex-shrink-0 align-items-center">
                      <ChartExportControl
                        variant="dots"
                        data={funnelChartOptions?.series?.map((s: any) => ({
                          Stage: s.name,
                          Count: s.data?.[0] ?? 0,
                        })) ?? []}
                        filename="Leads_Funnel_Overview"
                        cardId="leads-funnel-overview-card"
                      />
                    </div>
                  </div>

                  {/* ================= Body ================= */}
                  <div className="card-body">
                    <div className="lead-funnel-chart">
                      {funnelChartOptions.series?.[0]?.data?.length > 0 ? (
                        <ReactApexChart
                          options={{
                            ...funnelChartOptions,
                            chart: {
                              ...funnelChartOptions.chart,
                              animations: {
                                enabled: true,
                                dynamicAnimation: { speed: 600 },
                              },
                              toolbar: { show: false },
                              events: {
                                dataPointSelection: (
                                  event,
                                  chartContext,
                                  { dataPointIndex }
                                ) => {
                                  const stageName =
                                    funnelChartOptions.xaxis.categories[
                                    dataPointIndex
                                    ];
                                  if (stageName && currentUserName) {
                                    navigate(
                                      `/leads?stage=${encodeURIComponent(
                                        stageName
                                      )}&owner=${encodeURIComponent(
                                        currentUserName
                                      )}`
                                    );
                                  }
                                },
                              },
                            },
                            plotOptions: {
                              bar: {
                                horizontal: true,
                                borderRadius: 6,
                                distributed: false,
                                barHeight: "65%",
                              },
                            },
                            tooltip: {
                              theme: "light",
                              y: {
                                formatter: (val) => `${val} leads`,
                              },
                            },
                            colors: [
                              "#2196F3",
                              "#03A9F4",
                              "#00BCD4",
                              "#26A69A",
                              "#66BB6A",
                              "#9CCC65",
                            ],
                          }}
                          series={funnelChartOptions.series}
                          type="bar"
                          height={420}
                        />
                      ) : (
                        <div className="text-center text-muted py-4">
                          <i className="ti ti-filter-off fs-2 mb-2" />
                          <p className="mb-0">
                            No lead funnel data available
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 d-flex fade-in">
                <div className="card w-100 shadow-sm border-0 rounded-4" id="deal-pipeline-stage-card">
                  <div style={{ overflow: "visible" }} className="card-header border-0 pb-0 d-flex align-items-center justify-content-between">
                    <h4
                      className="fw-bold mb-2 d-flex align-items-center gap-2"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        currentUserName &&
                        navigate(
                          `/crm/deals?owner=${encodeURIComponent(
                            currentUserName
                          )}`
                        )
                      }
                    >
                      <i className="ti ti-adjustments-alt  text-primary"></i>
                      Deal Pipeline by Stage
                      <Tip
                        text="Visual representation of deals progressing across pipeline stages."
                        placement="top"
                      >
                        <i
                          className="fa fa-info-circle text-primary small"
                          style={{ cursor: "pointer" }}
                        />
                      </Tip>

                    </h4>
                    <div className="d-flex gap-1 flex-shrink-0 align-items-center">
                      <ChartExportControl
                        variant="dots"
                        data={dealStages?.map((s) => ({
                          Stage: s.label,
                          Count: s.total,
                        })) ?? []}
                        filename="Deal_Pipeline_by_Stage"
                        cardId="deal-pipeline-stage-card"
                      />
                    </div>
                  </div>

                  <div className="card-body">
                    {dealStages.length === 0 ? (
                      <div className="text-center text-muted py-4">
                        <i className="ti ti-briefcase-off fs-2 mb-2" />
                        <p className="mb-0">
                          No deal pipeline data
                        </p>
                      </div>
                    ) : (
                      dealStages.map((stage, idx) => {
                        const max = Math.max(
                          ...dealStages.map((s) => s.total || 0),
                          1
                        );
                        const percent = ((stage.total / max) * 100).toFixed(0);

                        // Normalize stage label
                        let normalized = stage.label.toLowerCase();

                        if (normalized.includes("won")) normalized = "won";
                        else if (normalized.includes("lost"))
                          normalized = "lost";
                        else if (normalized.includes("open"))
                          normalized = "open";
                        else if (normalized.includes("closed"))
                          normalized = "closed";
                        else normalized = "open"; // fallback safe

                        const STAGE_COLORS = {
                          open: {
                            bar: "linear-gradient(90deg, #60A5FA, #3B82F6)",
                            light: "#BFDBFE",
                          },
                          closed: {
                            bar: "linear-gradient(90deg, #A78BFA, #7C3AED)",
                            light: "#DDD6FE",
                          },
                          won: {
                            bar: "linear-gradient(90deg, #34D399, #059669)",
                            light: "#D1FAE5",
                          },
                          lost: {
                            bar: "linear-gradient(90deg, #FCA5A5, #EF4444)",
                            light: "#FEE2E2",
                          },
                        };

                        const colors =
                          STAGE_COLORS[
                          normalized as keyof typeof STAGE_COLORS
                          ] || STAGE_COLORS.open;

                        // Capitalized status for navigation
                        const finalStatus =
                          normalized.charAt(0).toUpperCase() +
                          normalized.slice(1);

                        return (
                          <div
                            key={idx}
                            className="mb-4 p-2 rounded-3 pipeline-item"
                            data-bs-toggle="tooltip"
                            title={`Click to view all ${finalStatus} deals`}
                            onClick={() =>
                              currentUserName &&
                              navigate(
                                `/crm/deals?status=${finalStatus}&owner=${encodeURIComponent(
                                  currentUserName
                                )}`
                              )
                            }
                            style={{
                              cursor: "pointer",
                              transition: "all 0.3s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "scale(1.01)";
                              e.currentTarget.style.boxShadow =
                                "0 4px 14px rgba(0,0,0,0.12)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "scale(1)";
                              e.currentTarget.style.boxShadow = "none";
                            }}
                          >
                            <div className="d-flex justify-content-between mb-1">
                              <strong>{stage.label}</strong>
                              <span className="text-muted fw-semibold">
                                {stage.total}
                              </span>
                            </div>

                            {/* Progress bar */}
                            <div
                              className="progress-container"
                              style={{
                                height: "28px",
                                background: colors.light,
                                borderRadius: "8px",
                                overflow: "hidden",
                              }}
                            >
                              <div
                                className="progress-fill"
                                style={{
                                  width: `${percent}%`,
                                  height: "100%",
                                  background: colors.bar,
                                  borderRadius: "8px",
                                  transition: "width 0.8s ease",
                                  display: "flex",
                                  alignItems: "center",
                                  paddingLeft: "10px",
                                  color: "#fff",
                                  fontWeight: 600,
                                  letterSpacing: "0.5px",
                                }}
                              >
                                {percent}%
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>

              {/* Upcoming Schedule */}
              <div className="col-md-6 d-flex fade-in">
                <div className="card upcoming-card flex-fill shadow-sm border-0 rounded-4">
                  {/* HEADER */}
                  <div className="card-header d-flex justify-content-between align-items-center border-0">
                    <h5 className="fw-bold mb-0 d-flex align-items-center gap-2">
                      <i className="ti ti-calendar-event text-primary"></i>
                      Upcoming Schedule
                      <Tip
                        text="Your upcoming meetings, tasks, and important events."
                        placement="top"
                      >
                        <i
                          className="fa fa-info-circle text-primary small"
                          style={{ cursor: "pointer" }}
                        />
                      </Tip>

                    </h5>

                    <div className="d-flex gap-1">
                      <span className="dot red"></span>
                      <span className="dot yellow"></span>
                      <span className="dot green"></span>
                    </div>
                  </div>

                  {/* BODY */}
                  <div className="card-body p-0">
                    <div
                      className="event-scroll-wrapper"
                      style={{ maxHeight: "340px", overflowY: "auto" }}
                    >
                      {events.length > 0 ? (
                        events.map((event, index) => {
                          const start = moment(event.event_start);
                          const end = moment(event.event_end);

                          // Premium color scheme
                          const bgColors = [
                            "#EEF2FF",
                            "#FFF6E5",
                            "#E8FFF3",
                            "#FFECEF",
                          ];
                          const barColors = [
                            "#6366F1",
                            "#F59E0B",
                            "#10B981",
                            "#EF4444",
                          ];

                          const bg = bgColors[index % bgColors.length];
                          const bar = barColors[index % barColors.length];

                          return (
                            <div
                              key={event.id}
                              className="p-3 mb-2 rounded-3 d-flex justify-content-between align-items-center schedule-item"
                              onMouseEnter={() => setHoveredIndex(index)}
                              onMouseLeave={() => setHoveredIndex(null)}
                              style={{
                                background: bg,
                                cursor: "pointer",
                                transition: "all 0.25s ease",
                                transform:
                                  hoveredIndex === index
                                    ? "scale(1.02)"
                                    : "scale(1)",
                                boxShadow:
                                  hoveredIndex === index
                                    ? "0 4px 12px rgba(0,0,0,0.12)"
                                    : "0 1px 4px rgba(0,0,0,0.05)",
                                borderLeft: `5px solid ${bar}`,
                              }}
                            >
                              {/* DATE BLOCK */}
                              <div
                                className="text-center me-3"
                                style={{
                                  minWidth: "70px",
                                  lineHeight: "1.2",
                                  color: bar,
                                }}
                              >
                                <div
                                  className="fw-bold"
                                  style={{ fontSize: "1.8rem" }}
                                >
                                  {start.format("DD")}
                                </div>
                                <div
                                  className="fw-semibold text-uppercase"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {start.format("MMM")}
                                </div>
                                <div
                                  className="small"
                                  style={{ fontSize: "0.7rem" }}
                                >
                                  {start.format("YYYY")}
                                </div>
                              </div>

                              {/* EVENT DETAILS */}
                              <div className="flex-grow-1 pe-2">
                                <div
                                  className="fw-bold text-dark text-truncate"
                                  style={{ maxWidth: "180px" }}
                                >
                                  {event.title}
                                </div>
                                <div className="small fw-semibold text-muted">
                                  {start.format("hh:mm A")} -{" "}
                                  {end.format("hh:mm A")}
                                </div>
                              </div>

                              {/* LOCATION */}
                              <div
                                className="text-end small fw-semibold text-muted"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                📍 {event.location || "No location"}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="text-center text-muted py-4">
                          <i className="ti ti-calendar-off fs-2 mb-2" />
                          <p className="mb-0">No upcoming events</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* FOOTER */}
                  <div className="card-footer border-0 text-center">
                    <Link
                      to={route.calendar}
                      className="btn btn-outline-primary btn-sm rounded-pill"
                    >
                      View Full Schedule
                    </Link>
                  </div>
                </div>
              </div>

              {/* Recent ToDos */}
              <div className="col-md-6 d-flex fade-in">
                <div className="card upcoming-card flex-fill shadow-sm rounded-4">
                  <div className="card-header d-flex justify-content-between align-items-center border-0 pb-2">
                    <h5 className="fw-bold mb-0 d-flex align-items-center gap-2">
                      <i className="ti ti-checklist text-primary"></i>
                      Recent ToDos
                      <Tip
                        text="These are your 5 most recent priority tasks."
                        placement="top"
                      >
                        <i
                          className="fa fa-info-circle text-primary small"
                          style={{ cursor: "pointer" }}
                        />
                      </Tip>

                    </h5>

                    <div className="d-flex gap-1">
                      <span className="dot red"></span>
                      <span className="dot yellow"></span>
                      <span className="dot green"></span>
                    </div>
                  </div>

                  <div className="card-body p-0">
                    <div
                      className="event-scroll-wrapper"
                      style={{ maxHeight: "350px", overflowY: "auto" }}
                    >
                      {todos.length > 0 ? (
                        todos.map((todo, index) => {
                          const bgColors = [
                            "#E9EAFE",
                            "#FFF1DA",
                            "#D6F5E8",
                            "#FFE9E9",
                          ];
                          const textColors = [
                            "#706FE5",
                            "#F4A700",
                            "#38B77C",
                            "#F25C5C",
                          ];

                          return (
                            <Tip
                              text={`Priority: ${todo.priority} | Status: ${todo.status}`}
                              placement="top"
                            >
                              <div
                                key={todo.todo_id}
                                className="todo-item-card p-3 mb-3 rounded-3 shadow-sm"
                                onClick={() => handleOpenTodo(todo)}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                style={{
                                  backgroundColor: bgColors[index % bgColors.length],
                                  cursor: "pointer",
                                  transform: hoveredIndex === index ? "scale(1.015)" : "scale(1)",
                                  transition: "all 0.25s ease",
                                  boxShadow:
                                    hoveredIndex === index
                                      ? "0 4px 12px rgba(0,0,0,0.15)"
                                      : "0 2px 6px rgba(0,0,0,0.08)",
                                  borderLeft: `5px solid ${textColors[index % textColors.length]}`,
                                }}
                              >
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                  <div className="flex-grow-1 pe-2">
                                    <div className="fw-bold text-dark text-truncate">
                                      {todo.title}
                                    </div>

                                    <div className="small fw-semibold text-muted">
                                      <span
                                        className="badge rounded-pill me-1"
                                        style={{
                                          background: "#fff",
                                          color: textColors[index % textColors.length],
                                          border: `1px solid ${textColors[index % textColors.length]}`,
                                        }}
                                      >
                                        {todo.priority}
                                      </span>
                                      <span className="text-muted">
                                        <i className="ti ti-progress" /> {todo.status}
                                      </span>
                                    </div>
                                  </div>

                                  <div className="text-muted small text-end" style={{ whiteSpace: "nowrap" }}>
                                    🧑‍💼 {todo.assigned_by || "-"}
                                  </div>
                                </div>

                                <div className="text-muted small d-flex align-items-center gap-1">
                                  <i className="ti ti-calendar-event"></i>
                                  {moment(todo.created_at).format("DD MMM YYYY")}
                                </div>
                              </div>
                            </Tip>

                          );
                        })
                      ) : (
                        <div className="text-center text-muted py-4">
                          <i className="ti ti-database-off fs-2 mb-2" />
                          <p className="mb-0">No recent todos</p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="card-footer border-0 d-flex justify-content-end">
                    <Link
                      to={route.todo}
                      className="btn btn-outline-primary btn-sm"
                    >
                      View All ToDos
                    </Link>
                  </div>
                </div>

                {/* ================== MODAL ================== */}
                {selectedTodo && (
                  <div
                    className={`modal fade ${showTodoModal ? "show d-block" : ""
                      }`}
                    tabIndex={-1}
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                    onClick={handleCloseTodo}
                  >
                    <div
                      className="modal-dialog modal-lg modal-dialog-centered"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="modal-content shadow-lg rounded-4">
                        <div className="modal-header bg-primary text-white rounded-top-4">
                          <h5 className="modal-title d-flex align-items-center gap-2">
                            <i className="ti ti-notes"></i>
                            ToDo Details
                          </h5>
                          <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={handleCloseTodo}
                          ></button>
                        </div>

                        <div className="modal-body bg-light">
                          <ul className="list-unstyled mb-0">
                            <li className="mb-2">
                              <strong>📌 Title:</strong> {selectedTodo.title}
                            </li>
                            <li className="mb-2">
                              <strong>🧾 Description:</strong>{" "}
                              {selectedTodo.description || "—"}
                            </li>
                            <li className="mb-2">
                              <strong>🎯 Priority:</strong>{" "}
                              {selectedTodo.priority}
                            </li>
                            <li className="mb-2">
                              <strong>📊 Status:</strong> {selectedTodo.status}
                            </li>
                            <li className="mb-2">
                              <strong>📅 Due Date:</strong>{" "}
                              {moment(selectedTodo.due_date).format(
                                "DD MMM YYYY, hh:mm A"
                              )}
                            </li>
                            <li className="mb-2">
                              <strong>👤 Assigned By:</strong>{" "}
                              {selectedTodo.assigned_by || "—"}
                            </li>
                            <li>
                              <strong>🕒 Created At:</strong>{" "}
                              {moment(selectedTodo.created_at).format(
                                "DD MMM YYYY, hh:mm A"
                              )}
                            </li>
                          </ul>
                        </div>

                        <div className="modal-footer">
                          <button
                            className="btn btn-secondary"
                            onClick={handleCloseTodo}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Sticky Notes */}
              <div className="col-md-12 mt-2">
                <div className="card">
                  <div className="card-header border-0 pb-0 d-flex justify-content-between align-items-center">
                    <h4>
                      <i className="ti ti-notes text-primary me-1" />
                      Sticky Notes
                    </h4>
                    <Button
                      onClick={() => openModal()}
                      className="mb-3"
                      aria-label="Add new note"
                    >
                      + Add Note
                    </Button>
                  </div>
                  <div className="sticky-note-container">
                    {notes.length === 0 ? (

                      <div className="text-center text-muted">
                        <i className="ti ti-notes-off fs-1 mb-2" />
                        <p className="mb-0 fw-semibold">No Sticky Notes Yet</p>
                        <small>Click “Add Note” to create one</small>
                      </div>


                    ) : (
                      notes.map((note, index) => (
                        <div
                          key={note.note_id}
                          className="sticky-note"
                          style={{ backgroundColor: getRandomNoteColor(index) }}
                        >
                          <button
                            className="delete-btn"
                            onClick={() => handleConfirmDelete(note.note_id)}
                            title="Delete"
                            aria-label="Delete note"
                          >
                            ×
                          </button>

                          <div
                            className="note-content"
                            onClick={() => openModal(note)}
                            title="Click to edit"
                          >
                            <h4>
                              <i>Sticky Note</i>
                            </h4>
                            <p>
                              {note.notes_decription || "No description provided"}
                            </p>
                          </div>
                        </div>
                      ))
                    )}
                  </div>

                </div>
                <Modal show={isModalOpen} onHide={closeModal} centered>
                  <Modal.Header closeButton>
                    <Modal.Title>
                      {selectedNote ? "Edit Note" : "Add Note"}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        saveNote(selectedNote, noteDescription);
                      }}
                    >
                      <div className="mb-3">
                        <label className="form-label">
                          Note Description:
                          <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          value={noteDescription}
                          onChange={(e) => setNoteDescription(e.target.value)}
                          placeholder="Enter your note..."
                          required
                          rows={4}
                        />
                      </div>
                      <div className="d-flex justify-content-end gap-2">
                        <Button variant="secondary" onClick={closeModal}>
                          Cancel
                        </Button>
                        <Button type="submit" variant="primary">
                          {selectedNote ? "Update" : "Save"}
                        </Button>
                      </div>
                    </form>
                  </Modal.Body>
                </Modal>
                <Modal
                  show={!!selectedNoteId}
                  onHide={() => setSelectedNoteId(null)}
                  centered
                >
                  <Modal.Body>
                    <div className="text-center">
                      <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                        <i className="ti ti-trash-x fs-36 text-danger" />
                      </div>
                      <h4 className="mb-2">Remove Note?</h4>
                      <p className="mb-0">
                        Are you sure you want to remove this note?
                      </p>
                      <div className="d-flex align-items-center justify-content-center mt-4">
                        <Button
                          variant="light"
                          onClick={() => setSelectedNoteId(null)}
                          className="me-2"
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="danger"
                          onClick={() => confirmDeleteNote(selectedNoteId)}
                        >
                          Yes, Delete it
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showScrollTop && (
        <button
          className="scroll-to-top-btn shadow"
          onClick={scrollToTop}
          title="Back to top"
        >
          <span style={{ fontSize: "20px", fontWeight: "bold" }}>↑</span>
        </button>
      )}
    </>
  );
};

export default LeadsDashboard;